import {createI18n} from 'vue-i18n'
import { enUS, ru as ruDateLocale } from 'date-fns/locale'
import { ky as kyDateLocale } from './lang/kyDate';
import ruMessages from './lang/ru.json'
import enMessages from './lang/en.json'
import kyMessages from './lang/ky.json'
import { config } from '@/script/cache/configuration'

// Базовые сообщения (могут быть импортированы из других файлов)
const baseMessages = {
    ru: ruMessages,
    en: enMessages,
    ky: kyMessages
}

/**
 * Глубокое слияние объектов. Вложенные объекты рекурсивно объединяются.
 * Приоритет у ключей из source (перезаписывают target).
 */
function deepMerge(target, source) {
    // Если source не объект или null — возвращаем source (перезапись примитивов)
    if (typeof source !== 'object' || source === null) {
        return source
    }

    // Создаём копию target, чтобы не мутировать оригинал
    const result = Array.isArray(target) ? [...target] : {...target}

    for (const key in source) {
        if (source.hasOwnProperty(key)) {
            const sourceValue = source[key]
            const targetValue = result[key]

            // Если оба значения — объекты (и не массивы), рекурсивно сливаем
            if (
                typeof sourceValue === 'object' &&
                sourceValue !== null &&
                typeof targetValue === 'object' &&
                targetValue !== null &&
                !Array.isArray(sourceValue) &&
                !Array.isArray(targetValue)
            ) {
                result[key] = deepMerge(targetValue, sourceValue)
            } else {
                // Иначе просто перезаписываем (приоритет у source)
                result[key] = sourceValue
            }
        }
    }

    return result
}

/**
 *  asdasd
 */
export async function getAvailableLanguages() {
    return config.lang
}

/**
 * хелпер функция для даты
 */
export const getDateFnsLocale = (localeCode) => {
    switch (localeCode) {
        case 'ru':
            return ruDateLocale;
        case 'ky':
            return kyDateLocale;
        default:
            return enUS;
    }
};

/**
 * Загружает внешние переводы и объединяет их с существующими.
 * Приоритет у ключей из внешнего файла (перезаписывают базовые).
 */
export async function loadExternalTranslations() {
    try {
        // Загрузка из public/lang.json
        const response = await fetch('/lang.json')

        if (!response.ok) {
            console.warn('Файл lang.json не найден, используются базовые переводы')
        } else {
            const externalMessages = await response.json()

            if (externalMessages) {
                // Проходим по каждому языку во внешнем файле
                Object.entries(externalMessages).forEach(([locale, messages]) => {
                    baseMessages[locale] = deepMerge(
                        baseMessages[locale] || {},
                        messages
                    )
                })

                console.log('Внешние переводы успешно загружены и объединены')
            }
        }

    } catch (error) {
        console.error('Ошибка загрузки lang.json:', error)
    }

// Создаем экземпляр i18n
    return createI18n({
        legacy: false, // Режим Composition API
        locale: 'ru',
        messages: baseMessages
    })

}
export default loadExternalTranslations
